var _rect, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 373,
    viewBox: "0 0 1600 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 212,
    fill: "url(#paint0_linear_764_2309)",
    fillOpacity: 0.09
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter0_d_764_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.87 26.3223C153.884 16.5971 164.985 17.045 174.582 17.8448C161.946 10.9668 149.949 14.0059 146.91 21.5237C132.994 8.72745 114.28 26.3223 113 34C116.039 30.3211 131.554 13.6861 147.87 26.3223Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M659.746 77.564C649.221 60.545 629.795 61.3288 613 62.7283C635.113 50.6918 656.107 56.0103 661.426 69.1664C685.779 46.773 718.529 77.564 720.768 91C715.45 84.5619 688.298 55.4506 659.746 77.564Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter1_d_764_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.7 353.483C551.721 338.896 568.372 339.568 582.768 340.767C563.814 330.45 545.819 335.009 541.26 346.286C520.387 327.091 492.315 353.483 490.395 365C494.954 359.482 518.227 334.529 542.7 353.483Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.83 -42.7041L1385.36 -49.1046C1387.99 -50.6422 1389.93 -48.6503 1390.61 -47.1994L1404.99 -21.784C1406.7 -22.9766 1411.55 -26.2745 1417.2 -29.9246C1422.85 -33.5747 1428.7 -28.8172 1430.92 -25.9822C1440.64 -11.9717 1461.12 17.6584 1465.29 24.0944C1469.47 30.5305 1466.26 36.8668 1464.14 39.2304L1453.86 47.0758L1446.74 35.7471L1452.91 30.4948L1420.91 -16.0354L1410.76 -9.70031C1412.27 -7.57683 1415.81 -2.06053 1417.46 1.20144C1418.8 3.86122 1417.31 5.61201 1416.57 5.63378C1413.72 7.34062 1407.37 10.9972 1404.72 11.9686C1402.06 12.94 1401.48 11.0925 1400.94 10.3591L1395.16 0.836513L1385.18 7.2044L1417.65 54.8511L1424.57 50.0914L1431.57 62.0768C1430.57 62.788 1427.36 64.8538 1422.47 67.427C1417.58 70.0003 1410.26 66.4619 1407.2 64.3709C1397.32 49.4739 1376.61 18.294 1372.8 12.7511C1369 7.2082 1371.23 0.99658 1375.86 -2.51585L1387.84 -10.3609C1383.17 -18.2965 1373.49 -34.8833 1372.15 -37.7466C1370.82 -40.6099 1372.95 -42.3102 1373.83 -42.7041Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.85 33.8385L1432.16 27.5363C1434.96 25.824 1437.38 27.6334 1438.24 28.7521C1447.32 42.5218 1465.93 70.731 1467.71 73.4105C1469.5 76.09 1467.69 78.3574 1466.56 79.1561C1464.84 80.6333 1460.36 84.0275 1456.19 85.7867C1452.01 87.5458 1450.07 85.6433 1449.62 84.4722C1440.35 70.4946 1421.45 41.8169 1419.98 38.9273C1418.51 36.0378 1420.62 34.3308 1421.85 33.8385Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.92 66.1576L1463.87 62.739C1460.56 58.8313 1454.2 50.6613 1455.31 49.243C1456.41 47.8248 1459.18 48.0836 1460.43 48.3902L1489.32 54.1739L1486.92 66.1576Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.11 69.3339L1448.01 85.6868L1446.3 94.2231C1445.78 96.8497 1447.71 100.823 1454.02 105.158L1478.15 109.989L1477.92 123.089C1468.97 121.698 1449.33 118.015 1442.26 114.415C1435.2 110.815 1432.95 100.941 1432.71 96.4535L1437.11 69.3339Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1665.47 72.0947L1663.21 59.1059C1662.76 56.0938 1659.98 55.8305 1658.43 56.2148L1629.62 60.99C1629.47 58.9036 1628.99 53.0591 1628.28 46.3716C1627.58 39.6841 1620.2 38.1164 1616.6 38.1684C1599.59 39.4071 1563.67 42.0827 1556.04 42.8759C1548.41 43.6691 1545.49 50.1415 1544.99 53.2785L1545.34 66.204L1558.63 64.6316L1558.84 56.5288L1615.15 52.2096L1616.59 64.0842C1613.99 64.2429 1607.48 64.956 1603.9 65.7205C1600.99 66.3438 1600.56 68.6019 1601.01 69.1947C1601.47 72.4812 1602.61 79.723 1603.53 82.3976C1604.44 85.0722 1606.24 84.3681 1607.15 84.3248L1618.19 82.8395L1619.5 94.6068L1562.04 99.2697L1561.39 90.8887L1547.67 92.9758C1547.74 94.1976 1548.15 97.9958 1549.22 103.414C1550.29 108.832 1557.64 112.312 1561.19 113.375C1578.98 111.707 1616.26 108.242 1622.96 107.723C1629.67 107.205 1633.1 101.566 1632.92 95.7567L1631.5 81.5028C1640.61 80.1543 1659.59 77.2682 1662.66 76.5119C1665.73 75.7557 1665.71 73.0234 1665.47 72.0947Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.74 82.7993L1574.17 70.8177C1573.75 67.5623 1570.82 66.8194 1569.41 66.8548C1552.99 68.4361 1519.35 71.6721 1516.15 71.9654C1512.94 72.2588 1512.31 75.0901 1512.4 76.469C1512.33 78.7341 1512.5 84.353 1513.76 88.708C1515.01 93.063 1517.71 93.3787 1518.9 92.9922C1535.6 91.425 1569.79 88.123 1572.96 87.4524C1576.13 86.7818 1576.14 84.0709 1575.74 82.7993Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1509.73 52.4626L1526.86 68.2509C1531.99 68.3766 1542.34 68.1907 1542.75 66.4413C1543.16 64.6919 1541.21 62.6981 1540.19 61.9198L1517.55 43.0694L1509.73 52.4626Z",
    fill: "white",
    fillOpacity: 0.03
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1538.54 93.2168L1518.97 95.0071L1513.4 101.698C1511.69 103.757 1507.38 104.746 1500.05 102.563L1481.13 86.8189L1471.08 95.2274C1477.78 101.311 1492.99 114.288 1500.23 117.525C1507.46 120.762 1516.56 116.308 1520.2 113.677L1538.54 93.2168Z",
    fill: "white",
    fillOpacity: 0.03
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_2309",
    x: 109,
    y: 14,
    width: 69.5818,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_2309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_2309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_764_2309",
    x: 486.395,
    y: 335,
    width: 100.373,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_2309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_2309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_764_2309",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBackground);
export default __webpack_public_path__ + "static/media/main-background.41405c053584ef66c02cea66e0949f6e.svg";
export { ForwardRef as ReactComponent };